import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import YouTube from "react-youtube";
import { position } from "polished";

import { down, fonts, spacings } from "~/src/config/vars";
import { Headline } from "~/src/components";

const opts = {
    playerVars: {
        rel: 0,
        modestbranding: 1,
        listType: "playlist",
        showinfo: 0,
    },
};

const BlockVideoItem = ({ video_id, title }) => {
    return (
        <SBlockVideoItem>
            <SVideo>
                <YouTube videoId={video_id} opts={opts} />
            </SVideo>
            <Headline level={3} size="mid" offset={["top-0"]}>
                <STitle>{title}</STitle>
            </Headline>
        </SBlockVideoItem>
    );
};

BlockVideoItem.propTypes = {
    video_id: PT.string,
    title: PT.string,
};

const SBlockVideoItem = styled.div`
    flex-shrink: 0;
    width: 100vh;
    margin: 0 0 0 5rem;
    padding: 2em 0 0;
    ${down("md")} {
        padding: 0;
        width: 100%;
        margin: 0;
        & + div {
            margin-top: ${spacings?.offset_40};
        }
    }
    ${down("sm")} {
    }
    & + div {
    }
`;

const SVideo = styled.div`
    padding-bottom: 56.25%;
    overflow: hidden;
    width: 100%;
    position: relative;
    height: 0;
    iframe {
        ${position("absolute", "0", "0", "0", "0")};
        width: 100%;
        height: 100%;
    }
`;

const STitle = styled.div`
    font-family: ${fonts?.ff_base};
    margin-top: ${spacings?.offset_20};
    ${down("sm")} {
        font-size: ${fonts?.fs_14};
        margin-top: ${spacings?.offset_10};
    }
`;

export default BlockVideoItem;
